import React, { useMemo } from 'react';
// import { Nav, NavItem, NavLink } from 'reactstrap';
// import { PanelHeader, ReplaceLink } from 'js/components';
import { PanelHeader } from 'js/components';
import { Route, Switch } from 'react-router-dom';
import { Breadcrumbs } from 'js/components/Breadcrumbs';
import { useParams, useRouteMatch } from 'react-router-dom';
import ManagedProductSettings from './ManagedProductSettings';
import ManagedProductCapabilities from './ManagedProductCapabilities';
import ManagedProductUserGroups from './ManagedProductUserGroups';
import ManagedProductOverview from './ManagedProductOverview';

// import styles from './ProductManagersDashboard.module.scss';

// const TABS = {
//   USER_GROUPS: 'user-groups',
//   CAPABILITIES: 'capabilities',
//   SETTINGS: 'settings',
//   OVERVIEW: 'overview',
// };

// function getActiveTab() {
//   if (
//     null !=
//     matchPath(window.location.pathname, {
//       path: '/w/:workspaceId/pm/products/:productId/settings',
//     })
//   ) {
//     return TABS.SETTINGS;
//   } else if (
//     null !=
//     matchPath(window.location.pathname, {
//       path: '/w/:workspaceId/pm/products/:productId/capabilities',
//     })
//   ) {
//     return TABS.CAPABILITIES;
//   } else if (
//     null !=
//     matchPath(window.location.pathname, {
//       path: '/w/:workspaceId/pm/products/:productId/user-groups',
//     })
//   ) {
//     return TABS.USER_GROUPS;
//   } else {
//     return TABS.OVERVIEW;
//   }
// }

function ManagedProductDashboard({
  hasLoaded,
  managedProduct,
  capabilitySets,
  onUpdate,
  onLinkCapability,
  onUnlinkCapability,
  onLinkCapabilities,
  onUnlinkCapabilities,
}) {
  const { workspaceId } = useParams();
  const match = useRouteMatch();

  // const matchedTab = useMemo(getActiveTab, [window.location.pathname]);

  const breadcrumbs = useMemo(
    () => [
      {
        label: 'Products',
        to: `/w/${workspaceId}/pm/products`,
      },
    ],
    [workspaceId]
  );

  return (
    <div>
      <PanelHeader size="flex">
        <div className="panel-body-no-label px-4">
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <div className="content-fluid">
            <div className="row">
              <div className="col-12">
                <h1>{managedProduct?.name}</h1>
              </div>
              <div className="col-12">{managedProduct?.description}</div>
            </div>
          </div>
        </div>
        {/* <div className="container-fluid">
          <Nav className="tab-nav nav-underline">
            <NavItem>
              <NavLink
                tag={ReplaceLink}
                active={matchedTab === TABS.OVERVIEW}
                data-view="active"
                to={`/w/${workspaceId}/pm/products/${productId}`}
              >
                Overview
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                tag={ReplaceLink}
                active={matchedTab === TABS.USER_GROUPS}
                data-view="active"
                to={`/w/${workspaceId}/pm/products/${productId}/user-groups`}
              >
                User groups
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                tag={ReplaceLink}
                data-view="results"
                to={`/w/${workspaceId}/pm/products/${productId}/capabilities`}
                active={matchedTab === TABS.CAPABILITIES}
              >
                Capabilities
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                tag={ReplaceLink}
                data-view="results"
                to={`/w/${workspaceId}/pm/products/${productId}/settings`}
                active={matchedTab === TABS.SETTINGS}
              >
                Settings
              </NavLink>
            </NavItem>
          </Nav>
        </div> */}
      </PanelHeader>
      <div className="content" style={{ position: 'relative' }}>
        {hasLoaded && (
          <Switch>
            <Route path={`${match.path}`}>
              <ManagedProductSettings
                managedProduct={managedProduct}
                onUpdate={onUpdate}
                capabilitySets={capabilitySets}
                onLinkCapability={onLinkCapability}
                onUnlinkCapability={onUnlinkCapability}
                onLinkCapabilities={onLinkCapabilities}
                onUnlinkCapabilities={onUnlinkCapabilities}
              />
            </Route>
            <Route path={`${match.url}/capabilities`}>
              <ManagedProductCapabilities managedProduct={managedProduct} />
            </Route>
            <Route path={`${match.path}/user-groups`}>
              <ManagedProductUserGroups managedProduct={managedProduct} />
            </Route>
            <Route path={`${match.path}`}>
              <ManagedProductOverview managedProduct={managedProduct} />
            </Route>
          </Switch>
        )}
      </div>
    </div>
  );
}

export default ManagedProductDashboard;
